module.exports = __webpack_public_path__ + "static/wsu-preview_1600.66597b6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/wsu-library/wsu-preview_1600.jpg
// module id = 481
// module chunks = 262546004982204